var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { h, getAssetPath, Host } from "@stencil/core";
import { ClickOutside } from "stencil-click-outside";
export class ChSelect {
    constructor() {
        this.name = undefined;
        this.iconSrc = undefined;
        this.arrowIconSrc = undefined;
        this.autoColor = false;
        this.disabled = undefined;
        this.width = undefined;
        this.height = undefined;
        this.toggle = false;
    }
    optionSelected = "";
    arrowTop = getAssetPath(`./select-assets/arrow-top.svg`);
    /**
     * @type EventEmitter
     *
     * Track component events (I.e. activation of dropdown component)
     */
    onToggle;
    /**
     * Emmits the item id
     */
    optionClickedEvent;
    el;
    // test
    optionsContainerEl;
    selectContainerEl;
    selectFlexContainerEl;
    ro;
    componentDidLoad() {
        this.ro = new ResizeObserver(entries => {
            for (const entry of entries) {
                this.calculateSelectWidth(entry.contentBoxSize[0].inlineSize);
                this.calculateSelectHeight();
            }
        });
        this.ro.observe(this.el);
        this.ro.observe(this.optionsContainerEl);
    }
    calculateSelectWidth(width) {
        if (width !== 0) {
            this.selectContainerEl.style.width = width + "px";
        }
    }
    calculateSelectHeight() {
        if (this.height !== "" && this.height) {
            this.selectFlexContainerEl.style.height = this.height;
        }
    }
    handleKeyDown(ev) {
        switch (ev.key) {
            case " ":
                this.toggleComponent();
                break;
            case "ArrowDown" || "ArrowUp":
                // todo
                break;
            default:
                break;
        }
    }
    closeSelect() {
        // close the select when user clicks outside of component area.
        if (this.toggle) {
            this.toggleComponent();
        }
    }
    optionClickedHandler(event) {
        const targetOption = event.currentTarget.id;
        this.toggleComponent();
        this.optionClickedEvent.emit({ "option-value": targetOption });
    }
    /*
     * This will manage the dropdown component event and state changes
     */
    toggleComponent() {
        this.toggle = !this.toggle;
        // When the user click emit the toggle state value
        this.onToggle.emit({ visible: this.toggle });
    }
    resolveIcon() {
        if (this.iconSrc !== undefined) {
            return this.iconSrc;
        }
        else {
            return "";
        }
    }
    resolveArrowIcon() {
        if (this.arrowIconSrc !== undefined) {
            return this.arrowIconSrc;
        }
        else {
            return this.arrowTop;
        }
    }
    render() {
        return (h(Host, { "aria-label": this.name, role: "listbox", "aria-expanded": this.toggle ? "true" : "false", tabindex: "0" }, h("div", { ref: el => (this.selectContainerEl = el), class: this.toggle
                ? "select-container uncollapsed"
                : "select-container collapsed" }, h("div", { class: "list-container", part: "select-box", onClick: () => this.toggleComponent(), ref: el => (this.selectFlexContainerEl = el) }, h("div", { class: "left-container" }, this.iconSrc && (h("span", { class: "icon custom-icon" }, h("ch-icon", { src: this.resolveIcon(), style: {
                "--select-icon-size": "var(--icon-size)",
                "--select-icon-color": `var(--icon-color)`
            } }))), h("span", { class: "text" }, this.optionSelected ? this.optionSelected : this.name)), h("span", { class: "icon arrow-icon" }, h("div", { part: "collapse-icon" })))), h("div", { ref: el => (this.optionsContainerEl = el), class: this.toggle ? "select-options active" : "select-options inactive", part: "select-options" }, h("slot", null))));
    }
    static get is() { return "ch-select"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-select.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-select.css"]
        };
    }
    static get assetsDirs() { return ["select-assets"]; }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "iconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "icon-src",
                "reflect": false
            },
            "arrowIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "arrow-icon-src",
                "reflect": false
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "false",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the icon will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": false
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "width",
                "reflect": false
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "height",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "toggle": {}
        };
    }
    static get events() {
        return [{
                "method": "onToggle",
                "name": "onToggle",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "type",
                            "text": "EventEmitter * Track component events (I.e. activation of dropdown component)"
                        }],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "optionClickedEvent",
                "name": "optionClickedEvent",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emmits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "handleKeyDown",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "itemClicked",
                "method": "optionClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
__decorate([
    ClickOutside()
], ChSelect.prototype, "closeSelect", null);
//# sourceMappingURL=ch-select.js.map
